export const getPoliticSpaceCreationObject = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};

export const getPoliticSpaceUpdatenObject = (data) => {
  let objectTemp = {
    name: data.name,
  };

  return objectTemp;
};
